import React from "react";

export const DashPerformance = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99967 1.63821V3.05402C4.04512 3.8452 2.66634 5.76142 2.66634 7.99967C2.66634 10.9452 5.05415 13.333 7.99967 13.333C10.2379 13.333 12.1541 11.9542 12.9453 9.99967H14.3611C13.5116 12.7044 10.9847 14.6663 7.99967 14.6663C4.31777 14.6663 1.33301 11.6815 1.33301 7.99967C1.33301 5.01458 3.29493 2.48772 5.99967 1.63821ZM7.99967 1.33301C11.6815 1.33301 14.6663 4.31777 14.6663 7.99967C14.6663 8.22467 14.6552 8.44707 14.6334 8.66634H7.33301V1.36593C7.55227 1.34415 7.77467 1.33301 7.99967 1.33301ZM8.66634 2.7076V7.33301H13.2917C12.9909 4.92053 11.0788 3.00843 8.66634 2.7076Z"
        fill="currentColor"
      />
    </svg>
  );
};
